export default "__VITE_ASSET__BqY2lLw2__"